import { SubscriptionInvoice } from "../../../types/billing";

export const UNPAID_INVOICE_STATUSES = ["pending", "failed", "overdue", "open"];

export const isUnpaidInvoice = (inv: SubscriptionInvoice) =>
  UNPAID_INVOICE_STATUSES.includes(inv.status) &&
  (inv.amountDue || inv.totalAmountCents || 0) > 0;

export const getInvoiceMatchKeys = (inv: SubscriptionInvoice) =>
  [inv.id, inv._id, inv.billingLedger?.identifier].filter(
    (key): key is string => !!key,
  );

export const countSettledInvoices = (
  attemptedInvoices: SubscriptionInvoice[],
  remainingUnpaid: SubscriptionInvoice[],
) => {
  const remainingKeys = new Set(remainingUnpaid.flatMap(getInvoiceMatchKeys));

  return attemptedInvoices.filter((inv) =>
    getInvoiceMatchKeys(inv).every((key) => !remainingKeys.has(key)),
  ).length;
};

export const formatInvoiceCount = (count: number) =>
  `${count} ${count === 1 ? "invoice" : "invoices"}`;

export const formatPartialSettlementMessage = (
  settledCount: number,
  remainingAttemptedCount: number,
  retryHint: string,
) =>
  `${formatInvoiceCount(settledCount)} paid. ${formatInvoiceCount(
    remainingAttemptedCount,
  )} ${
    remainingAttemptedCount === 1 ? "still needs" : "still need"
  } payment. ${retryHint}`;
